import { createStore } from 'redux'
import { candidates } from '../candidates.js'

export const SET_ACTIVE_CANDIDATE = "SET_ACTIVE_CANDIDATE"
export const RESET_ACTIVE_CANDIDATE = "RESET_ACTIVE_CANDIDATE"
export const RESET_CANDIDATE = "RESET_CANDIDATE"
export const MOVE_CANDIDATE = "MOVE_CANDIDATE"

function normalizeBallot(ballot) {
  return Array(candidates.length).fill(0).map((v,i) => {
    if (i < ballot.length) {
      return ballot[i]
    } else {
      return new Set()
    }
  })
}

export function normalizeState(state) {
  return {
    ...state,
    ballot: normalizeBallot(state.ballot)
  }
}

function setActiveCandidate(state, activeCandidate) {
  return { ...state, activeCandidate }
}

function resetActiveCandidate(state) {
  return setActiveCandidate(state, null)
}

function resetCandidate(state, candidate) {
  return normalizeState({
    remaining: new Set(state.remaining).add(candidate),
    ballot: state.ballot.map(row => {
      const newRow = new Set(row)
      newRow.delete(candidate)
      return newRow
    })
  })
}

function moveCandidate(state, candidate, to) {
  const newRemaining = new Set(state.remaining)
  newRemaining.delete(candidate)
  return normalizeState({
    remaining: newRemaining,
    ballot: state.ballot.map((row, i) => {
      if (i !== to) {
        const newRow = new Set(row)
        newRow.delete(candidate)
        return newRow
      } else {
        return new Set(row).add(candidate)
      }
    })
  })
}

export function storeReducer(state, action) {
  switch (action.type) {
    case SET_ACTIVE_CANDIDATE:
      return setActiveCandidate(state, action.payload)
    case RESET_ACTIVE_CANDIDATE:
      return resetActiveCandidate(state)
    case RESET_CANDIDATE:
      return resetCandidate(state, action.payload)
    case MOVE_CANDIDATE:
      return moveCandidate(state, action.payload.candidate, action.payload.to)
    default:
      return state
  }
}

export function selectRemaining(state) {
  return state.remaining
}

export function selectDraggedCandidate(state) {
  return state.draggedCandidate
}

export function selectBallot(state) {
  return state.ballot
}

export function selectActiveCandidate(state) {
  return state.activeCandidate
}

export function selectIsStateValid(state) {
  return state.remaining.size === 0
}

export const store = createStore(storeReducer, normalizeState({
  draggedCandidate: null,
  activeCandidate: null,
  remaining: new Set(candidates),
  ballot: [ new Set() ]
}), window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__())
